import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { FC } from "react";

interface IRideHistoryLogTabsProps {
  activeTab: "audit" | "processes";
  onTabChange: (tab: "audit" | "processes") => void;
  auditLogsCount: number;
  processesCount: number;
}

export const RideHistoryLogTabs: FC<IRideHistoryLogTabsProps> = ({
  activeTab,
  onTabChange,
  auditLogsCount,
  processesCount,
}) => {
  const handleTabChange = (
    _: React.MouseEvent<HTMLElement>,
    newValue: "audit" | "processes" | null,
  ): void => {
    if (newValue !== null) {
      onTabChange(newValue);
    }
  };

  return (
    <div className="ride-history-log__tabs-container">
      <ToggleButtonGroup
        color="primary"
        size="small"
        value={activeTab}
        exclusive
        onChange={handleTabChange}
        aria-label="history tabs"
        className="ride-history-log__tabs"
      >
        <ToggleButton
          value="audit"
          disabled={activeTab === "audit"}
          className="ride-history-log__tab"
        >
          Audit logs ({auditLogsCount})
        </ToggleButton>
        <ToggleButton
          value="processes"
          disabled={activeTab === "processes"}
          className="ride-history-log__tab"
        >
          Processes ({processesCount})
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};
